// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1knWZ","bigColWidth":"Table_bigColWidth__2Iqe0","biggerColWidth":"Table_biggerColWidth__3ZTmy","row":"Table_row__Y9TWN","col":"Table_col__SmOJJ"};